import React, { Component } from "react";
import axios from "axios";
import styles from "./ApproveEmployer.scss";
import Loader from "../../Loader/Loader";
import { Link } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faAddressCard, faUserPlus, faUsers } from "@fortawesome/free-solid-svg-icons";

export default class ApproveEmployer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			error: undefined
		};
	}

	async componentDidMount() {
		// Make call to database using ID from URL
		let id = this.props.location.search.substring(1);
		console.log("ID:", id);
		axios.defaults.headers.common["Authorization"] = localStorage.getItem(
			"jwt"
		);
		await axios
			.post("/api/admin/approveemployer/", { _id: id })
			.then(res => {
				this.setState({
					loading: false
				});
			})
			.catch(e => {
				console.log("e", e);
				this.setState({
					loading: false,
					error: true
				});
			});
	}

	render() {
		if (this.state.error) {
			return (
				<div className={styles.page}>
					<h5>This link is invalid.</h5>
				</div>
			);
		} else if (this.state.loading) {
			return <Loader />;
		} else {
			return (
				<div className={styles.page}>
					<h1>You've validated the request!</h1>
					<p>
						Thank you! The employer will be notified via email that
						the approval has been completed.
					</p>
					<Link to="/admin">
						<a> Back to Admin Portal </a>
					</Link>
				</div>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/Admin/ApproveEmployer.js